import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const useSocialProofAuthUIExperiment = (triggerExperiment = true) => {
  // MW-8.3: Social Proof Message on Auth UI placeholder custom hook
  useBinaryExperiment(FLAG.MW_8_3_SOCIAL_PROOF_MESSAGE, { triggerExperiment });
};
